import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  createReducerName,
  createCombineReducers
} from 'mt-react-common/modules/comments/reducers/list/reducer';
import Comments from '../../CommentsList/index';

class CommentsIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: createReducerName(
        `commentsList-${this.props.modelClass}-${this.props.modelId}`
      )
    };
  }

  componentWillMount() {
    createCombineReducers(this.state.reducerName);
  }

  render() {
    return (
      <React.Fragment>
        <Comments {...this.props} reducerName={this.state.reducerName} />
      </React.Fragment>
    );
  }
}

CommentsIn.defaultProps = {};

CommentsIn.propTypes = {
  modelClass: PropTypes.string.isRequired,
  modelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  commentsOwnerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  commentsInStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired
};

export default CommentsIn;



// WEBPACK FOOTER //
// ./src/components/Comment/ReducerWrappers/CommentsIn/CommentsIn.js